// React
import * as React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'

import Text from 'src/presentations/elements/Text'
import ButtonType from 'src/presentations/elements/Button/props'
import Button from 'src/presentations/elements/Button'

const StyledHeader = styled.div`
  margin-left: 0px;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 20px;
  height: 50px;

  h3 {
    margin: 3px 0;
  }
`
const Separator = styled.div`
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
`

interface Props extends RouteComponentProps<{}> {
  /** Title of Editor */
  title?: string | JSX.Element | Element

  /** Description help Editor */
  help?: string

  /** add separator */
  separator?: boolean

  /** Add actions bar */
  actions?: ButtonType[]
}

class Header extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    separator: true,
    actions: [],
  }

  /**
   * Display the button to actions
   */
  renderActions = () => {
    return (
      <>
        {this.props.actions!.map((action: ButtonType, key: number) => {
          return (
            <Button key={key} themeColor="light" size="small" {...action} />
          )
        })}
      </>
    )
  }

  /**
   * Render the main content
   * @returns {any}
   */
  render() {
    return (
      <StyledHeader className='header'>
        {this.props.title && (
          <Row>
            <Col md={6}>
              {typeof this.props.title === 'string' ? (
                <h3>
                  <Text useWordBoundary={50} capitalizeFirstLetter={true}>
                    {this.props.title}
                  </Text>
                </h3>
              ) : ""}
              {typeof this.props.title !== 'string' ? (
                <div>{this.props.title}</div>
              ) : ""}
            </Col>
            {this.renderActions() ? <Col md={6} className={'pull-right'}>
              <div className={'pull-right'}> {this.renderActions()} </div>
            </Col> : ""}
          </Row>
        )}
        {this.props.separator ? (<Separator />) : ""}
      </StyledHeader>
    )
  }
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/presentations/views/PageView/Header.tsx